<template>
  <div class="d-flex justify-content-center custom-container align-items-center">
    <div class="loader-wrapper" v-if="isLoading || !currentImage">
      <div v-if="isEmpty">
        {{ trans.get('image_verification.no_more_images') }}
      </div>
      <CircleLoader v-else />
    </div>
    <div v-else>
      <div class="d-inline-flex flex-column justify-content-center align-items-center">
        <div class="d-flex justify-content-around image-container">
          <img v-if="currentImage.compare_image" class="image" :src="currentImage.compare_image" alt="">
          <img class="image" :src="currentImage.url" alt="">
        </div>
        <div class="d-flex align-items-center w-100 justify-content-center mt-2">
          <div role="button" class="d-flex flex-column justify-content-center align-items-center mr-5" @click="reject()">
            <img src="../../../images/icons/reject.svg" alt="">
            <h4>{{ trans.get('image_verification.reject') }}</h4>
          </div>
          <div role="button" class="d-flex flex-column justify-content-center align-items-center mr-5" @click="maybe()">
            <img src="../../../images/icons/maybe.svg" alt="">
            <h4>{{ trans.get('image_verification.maybe') }}</h4>
          </div>
          <div role="button" class="d-flex flex-column justify-content-center align-items-center cursor-pointer" @click="accept()">
            <img src="../../../images/icons/accept.svg" alt="">
            <h4>{{ trans.get('image_verification.accept') }}</h4>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CircleLoader from '../Common/CircleLoader.vue';

export default {
  name: 'ImageVerificationActive',
  components: { CircleLoader },
  data() {
    return {
      isLoading: true,
      isEmpty: false,
      images: [],
      duration: 0,
      startTime: null,
    };
  },
  watch: {
    async images(val) {
      if (val.length === 0) {
        this.isEmpty = true;
      } else {
        this.isEmpty = false;

        if (val.length < 2) {
          await this.getImage();
        }
        if (val.length > 0) {
          this.isLoading = false;
          this.startTimer();
        }
      }
    }
  },
  computed: {
    currentImage() {
      return this.images.length ? this.images[0] : null;
    }
  },
  methods: {
    async getImage() {
      try {
        const response = await axios.get('/ajax/image-verifications');
        const data = response.data.data;

        if (data.length) {
          if (this.images.length) {
            data.forEach(image => {
              const exists = this.images.findIndex(x => x.id === image.id) !== -1;
              if (!exists) {
                this.images.push(image);
              }
            });
          } else {
            this.images = data;
          }
        }
      } catch (error) {
        console.error(error);
        this.$notify({
          type: 'error',
          title: 'Serverfehler',
          text: error.response?.data?.message || 'Unknown error',
        });
      }
    },

    reject() {
      this.sendDecision('reject');
    },
    maybe() {
      this.sendDecision('review_required');
    },
    accept() {
      this.sendDecision('accept');
    },

    async sendDecision(decision) {
      if (!this.currentImage) return;

      this.isLoading = true;
      this.calculateDuration();

      try {
        await axios.post('/ajax/image-verifications', {
          decision,
          portal_id: this.currentImage.portal_id,
          image_id: this.currentImage.id,
          duration: this.duration,
        });

        this.removeImage();
        this.$emit('verified', this.duration);
      } catch (error) {
        let notification = {
          type: 'error',
          title: 'Serverfehler',
        };

        if (error.response?.status === 422) {
          notification.text = this.trans.get('image_verification.already_verified');
        } else {
          notification.text = this.trans.get('image_verification.error') + ' ' + error.response?.status;
        }

        this.$notify(notification);
        this.removeImage();
      }
    },

    startTimer() {
      this.startTime = Date.now();
    },
    calculateDuration() {
      if (this.startTime) {
        this.duration = Math.round(Date.now() - this.startTime);
        this.startTime = null;
      }
    },
    removeImage() {
      this.images = this.images.filter(image => image.id !== this.currentImage.id);
    },
  },

  async mounted() {
    await this.getImage();

    if (this.images.length === 0) {
      this.isEmpty = true;
    }

    this.refreshInterval = setInterval(async () => {
      if (this.images.length === 0) {
        await this.getImage();
      }
    }, 5000);
  },

  beforeUnmount() {
    clearInterval(this.refreshInterval);
  }
};
</script>

<style scoped>
.image {
  height: 500px;
  max-height: 500px;
  max-width: 100%;
  width: auto;
  object-fit: contain;
}

.loader-wrapper {
  height: 500px;
  max-height: 500px;
  display: flex;
  align-items: center;
}

.image-container {
  gap: 50px;
  flex-wrap: wrap;
}
</style>
